import React from 'react'

const SvgStrollerOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.6 3.685a1.443 1.443 0 011.422-1.686h1.854a7.092 7.092 0 017.092 6.984l-1 .016v1h-7.446a1 1 0 01-.986-.832L9.6 3.685zm8.251 4.314c-.5-2.291-2.54-4-4.975-4h-1.194l.683 4h5.486z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.011 3.686a1 1 0 10-2 0V8H7V5.5A1.5 1.5 0 005.5 4H3a1 1 0 000 2h2v2a1 1 0 00-1 1 9.68 9.68 0 00.592 3.34 9.164 9.164 0 001.7 2.914 8.003 8.003 0 002.59 1.98 7.222 7.222 0 003.102.705 7.222 7.222 0 003.1-.705 8.004 8.004 0 002.591-1.98 9.165 9.165 0 001.7-2.913A9.68 9.68 0 0019.968 9a1 1 0 00-1-1h-3.956V3.686zM5.5 22a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-1.666a.833.833 0 100-1.667.833.833 0 000 1.666zM18.5 22a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-1.666a.833.833 0 100-1.667.833.833 0 000 1.666zM6.064 10c.074.564.21 1.112.408 1.66.311.86.764 1.633 1.327 2.278a6.003 6.003 0 001.941 1.489c.716.34 1.478.512 2.244.512.765 0 1.527-.172 2.243-.512a6.003 6.003 0 001.941-1.489 7.163 7.163 0 001.327-2.277A7.819 7.819 0 0017.903 10H6.064z'
    />
  </svg>
)

export default SvgStrollerOutline
